import { ComponentContentTypes } from '@constants/enums/content-types'

import { VideoAsset } from '@components/asset/video/video'
import { AssetImage } from '@components/contentful-content-types/asset-image/asset-image'
import ComponentAssetGrid from '@components/contentful-content-types/component-asset-grid/component-asset-grid'
import { CtaButton } from '@components/cta/cta-button/cta-button'
import { ComponentCtaGroup } from '@components/cta/cta-group/cta-group'
import { buildContentRenderer } from '@components/renderer/generic'
import { SectionFaq } from '@components/section/faq/faq'
import { SectionGroup } from '@components/section/group/group'
import { HeroSection } from '@components/section/hero/hero'
import { MultiColumnSection } from '@components/section/multi-column/multi-column'
import { SingleColumnSection } from '@components/section/single-column/single-column'
import { TwoColumnSection } from '@components/section/two-column/two-column'
import { TitleDescriptionBlock } from '@components/title-description-block/title-description-block'
import { AuthAndDeviceTypeCtaVariationContainer } from '@components/variation-container/auth-and-device-type-cta'

const contentTypeMap = {
  [ComponentContentTypes.ComponentTitleBlockDescription]: TitleDescriptionBlock,
  [ComponentContentTypes.SectionHero]: HeroSection,
  [ComponentContentTypes.SectionFaq]: SectionFaq,
  [ComponentContentTypes.SectionMultiColumn]: MultiColumnSection,
  [ComponentContentTypes.SectionSingleColumn]: SingleColumnSection,
  [ComponentContentTypes.SectionTwoColumns]: TwoColumnSection,
  [ComponentContentTypes.SectionGroup]: SectionGroup,
  [ComponentContentTypes.AssetImage]: AssetImage,
  [ComponentContentTypes.ComponentAssetGrid]: ComponentAssetGrid,
  //   [ComponentContentTypes.SectionTabs]: TabsSection,
  //   [ComponentContentTypes.SectionVerticalTabs]: VerticalTabsSection,
  [ComponentContentTypes.ComponentCtaButton]: CtaButton,
  //   [ComponentContentTypes.ComponentSocialShareWidget]: SocialShareWidget,
  //   [ComponentContentTypes.ComponentBanner]: BannerComponent,
  [ComponentContentTypes.ComponentCtaGroup]: ComponentCtaGroup,
  [ComponentContentTypes.AssetVideo]: VideoAsset,
  //   [ComponentContentTypes.VariationContainerDeviceType]: DeviceTypeVariationContainer,
  [ComponentContentTypes.VariationContainerAuthAndDeviceTypeCta]:
    AuthAndDeviceTypeCtaVariationContainer,
  //   [ComponentContentTypes.AssetPdf]: PDFAsset,
} as const

export const ContentRenderer = buildContentRenderer(contentTypeMap)
